'use client';

import React, { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function MobileCTABar() {
  const { language } = useLanguage();
  const t = getTranslations(language)?.mobileCta;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`mobile-cta-bar transition-all duration-500 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="flex gap-3">
        <a
          href="#download"
          className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-dispatch-cyan text-dispatch-bg rounded-xl font-bold font-mono text-sm shadow-cyan-sm"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.42c1.42.07 2.38.74 3.2.8 1.22-.24 2.39-.93 3.72-.84 1.58.13 2.77.77 3.54 1.96-3.27 1.96-2.49 6.27.54 7.48-.65 1.72-1.49 3.43-3 4.46z"/>
          </svg>
          {t?.appStore}
        </a>
        <a
          href="#download"
          className="flex-1 flex items-center justify-center gap-2 py-3.5 border border-dispatch-cyan/40 text-dispatch-cyan rounded-xl font-bold font-mono text-sm"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3.18 23.76c.3.17.65.18.97.04L14.76 12 3.15.2C2.83.06 2.48.07 2.18.24A1.5 1.5 0 001.5 1.5v21c0 .55.28 1.04.68 1.26zm16.57-11.3l-2.7-1.56-3.13 3.13 3.13 3.12 2.71-1.56a1.5 1.5 0 000-3.13z"/>
          </svg>
          {t?.googlePlay}
        </a>
      </div>
    </div>
  );
}